import { STEP_ORDER, type CheckoutStep } from "../state"

const RESUME_KEY = "meucontroleai:checkout-resume"

/** How long a left wizard waits to be picked up where the customer stopped. */
export const CHECKOUT_RESUME_TTL_MS = 30 * 60 * 1000

function isStep(value: unknown): value is CheckoutStep {
  return typeof value === "string" && (STEP_ORDER as readonly string[]).includes(value)
}

/** The wizard step a checkout path shows ("/cart/checkout/extras" → "extras"); null elsewhere. */
export function checkoutStepOf(pathname: string): CheckoutStep | null {
  const match = /^\/cart\/checkout\/([a-z]+)\/?$/.exec(pathname)
  return match && isStep(match[1]) ? match[1] : null
}

/** Remembers, for this tab, the step the customer left the checkout from. */
export function rememberCheckoutStep(step: CheckoutStep, now: number = Date.now()): void {
  try {
    sessionStorage.setItem(RESUME_KEY, JSON.stringify({ step, savedAt: now }))
  } catch {
    return
  }
}

/** The step to resume at, when the customer left the checkout less than {@link CHECKOUT_RESUME_TTL_MS} ago in this tab. */
export function resumableCheckoutStep(now: number = Date.now()): CheckoutStep | null {
  try {
    const raw = sessionStorage.getItem(RESUME_KEY)
    if (!raw) return null
    const parsed: unknown = JSON.parse(raw)
    if (typeof parsed !== "object" || parsed === null || !("step" in parsed) || !("savedAt" in parsed)) return null
    const { step, savedAt } = parsed
    if (!isStep(step) || typeof savedAt !== "number" || now - savedAt > CHECKOUT_RESUME_TTL_MS) return null
    return step
  } catch {
    return null
  }
}

/** Drops the remembered step (picked up, or the order went through). */
export function forgetCheckoutStep(): void {
  try {
    sessionStorage.removeItem(RESUME_KEY)
  } catch {
    return
  }
}
